import type { RouteLocationRaw } from 'vue-router';

/**
 * Used for main index page.
 *
 * Used to redirect to first step of last used product flow, or to external Jungfrau landing page.
 */
export default defineNuxtRouteMiddleware((to, from) => {
    const runtimeConfig = useRuntimeConfig();
    const { isFeatureEnabled } = useFeatureFlags();

    // If landing page feature is disabled (PRODUCTION), dont show the landing page
    // but redirect accordingly
    if (!isFeatureEnabled('landingpage')) {
        const lastProductConfig = getProductConfigFromRoute(from);
        const lastProductId = getProductIdFromRoute(from);
        const lastFlowType = getFlowTypeFromRoute(from) ?? 'booking';

        // If we were in an offer flow previously, redirect to its first step
        if (lastProductConfig && lastProductId) {
            return navigateTo(getFirstFlowRoute(lastProductConfig.steps, lastProductId, lastFlowType));
        }
        // If not, redirect to Jungfrau landing page
        else {
            let redirect: RouteLocationRaw = runtimeConfig.public.urlJungfrau;

            // Add locale parameter when redirecting after logout
            // Locale path param is required as TYPO3 will redirect and lose the locale param otherwise
            if (String(to.name).startsWith('loggedout')) {
                const locale = useNuxtApp().$i18n.locale.value;
                let redirectLocale;

                switch (locale) {
                    case 'de':
                        redirectLocale = 'de-ch';
                        break;
                    case 'en':
                        redirectLocale = 'en-gb';
                        break;
                    case 'fr':
                        redirectLocale = 'fr-ch';
                        break;
                }

                redirect = {
                    path: `${runtimeConfig.public.urlJungfrau}/${redirectLocale}`,
                    query: {
                        logout: 'true',
                    },
                };
            }

            setTimeout(() => {
                return navigateTo(redirect, { external: true });
            }, 500);
        }
    }
});
